import {
  getSummarySubTotals,
  usePricing,
} from '@customink/project-service-react-components';

import { LineItem } from './LineItem';

import { useFeatureFlagEnabled } from '@/hooks/FeatureFlags/useFeatureFlagEnabled';
import { useHasSignificantVolumeDiscount } from '@/hooks/Pricing';
import { VOLUME_DISCOUNT_FLAG_NAME } from '@/utils/featureFlags';

export function VolumeDiscountLineItem() {
  const { data: pricingData, isLoading, isFetching } = usePricing();
  const hasSignificantVolumeDiscount = useHasSignificantVolumeDiscount();
  const isVolumeDiscountEnabled = useFeatureFlagEnabled(
    VOLUME_DISCOUNT_FLAG_NAME,
  );

  const volumeDiscountSavings = getSummarySubTotals(
    pricingData.grouped,
    'volume_discount_savings',
  );

  const sxValue = {
    color: 'success.main',
  };

  const showVolumeDiscount =
    isVolumeDiscountEnabled && hasSignificantVolumeDiscount;

  return showVolumeDiscount ? (
    <LineItem
      isLoading={isLoading || isFetching}
      name="Volume Discount"
      sxValue={sxValue}
      tagPrefix="volume-discount"
      value={`-$${volumeDiscountSavings}`}
    />
  ) : null;
}
